import React, { useState } from "react";
import styles from '../styles/detail.module.scss'
import { useMessageContext } from "../context";
import Icon from "@/wmCompoments/Icon";
import { useDelete, useGetUnreadForType } from "../hooks/useMessageCenter";
import ConfirmDialog from "@/wmCompoments/confirmDialog";
import ErrorMessageDialog from "@/antComponent/errorMessageDialog";
import Toast from "@/wmCompoments/toast";
import { useTranslation } from "react-i18next";

const Detail = () => {
  const { t } = useTranslation('messageCenter')

  // 获取当前上下文中的通用数据和方法
  const { selectedItem, currentMessage, setShowPanel, mutateList } = useMessageContext();
  // 获取站内信未读数
  const { mutate } = useGetUnreadForType()
  // 删除站内信
  const { trigger: triggerDelete } = useDelete()
  // 打开/关闭 删除确认弹窗
  const [showConfirm, setShowConfirm] = useState(false);

  const handleDelete = async () => {
    try {
      await triggerDelete({
        brType: selectedItem?.brType,
        msgType: selectedItem?.msgType,
        id: currentMessage?.id,
        userSystem: '1'
      })
      await Promise.all([mutate(), mutateList()])
      Toast.show(t('actionSuccess'))
      setShowPanel(false)
    } catch (error: any) {
      ErrorMessageDialog(error?.message ?? JSON.stringify(error));
    }
  }

  return (
    <div className={styles.detail}>
      <div 
        className={styles.detail_header} 
        onClick={()=>setShowPanel(false)} // 关闭详情
      >
        <Icon name="icon-general-arrow-line-left" />
        <div>{t('details')}</div>
      </div>

      <div className={styles.detail_content}>
        <div>
          <div className={styles.title}>
            <span>{currentMessage.title}</span>
            {selectedItem?.msgType !== 3 && <Icon 
              name="icon-message-delete" 
              className={styles.delete} 
              onClick={() => setShowConfirm(true)}
            />}
          </div>
          <div className={styles.sendTime}>{currentMessage.sendTime}</div>
        </div>

        <div className={styles.line}></div>

        <div className={styles.content}>{currentMessage.content}</div>
      </div>

      {/* 删除确认弹窗 */}
      <ConfirmDialog
        visible={showConfirm}
        title={t('friendlyReminder')}
        content={t('confirmDeleteMessage')}
        onCancel={() => setShowConfirm(false)}
        onConfirm={handleDelete}
        textConfirm={t('confirm')}
        textCancel={t('cancel')}
      />
    </div>
  )
}

export default Detail